<template>
  <div class="panel">
    <div v-if="sortedData.length">

      <p>{{ sortedData.length }} items in selection from {{startYear}}-{{endYear}} at:</p>
      <ul>
        <li v-for=" occ in occurances(whereFrom(sortedData))" :key="occ[0]">
          <a
            class="city"
            @click="setPlace('place_name', [occ[0]], true)"
            @mouseover="setHoverPlace(occ[0])"
          >{{`${occ[0]} (${occ[1]})`}}</a>
        </li>
      </ul>

      <p><a @click="clearSelect()">Clear selection</a></p>
      <ul class="sorting">
        <li
          v-for="sort in sortOptions"
          :class="{selected: sortKey == sort.id}"
          :key="sort.id"
          @click="setSortKey(sort.id)"
        >
          {{ sort.label }}
          <span
            v-if="sortKey == sort.id"
            class="sortDirection"
          >{{ sortDirection == "asc" ? "↑" : "↓"}}</span>
        </li>
      </ul>

      <ol class="items">
        <li v-for="item in sortedData" :key="item.nid">
          <a :href="siteUrl + item.nid" target="_blank">
            <h3 v-html="item.title"/>
            <p>
              <em>{{ item.field_object_year_start }}</em> - {{ item.field_address }} <span v-if="item.last_name">- {{ item.last_name}}</span>
            </p>
            <img id="img" :src="getPhotoUrl(item.field_media_leadimage, 250)">
          </a>
        </li>
      </ol>

    </div>
    <div v-else>
      <h2>Sound & Science: Digital Histories</h2>
      <p>Nothing selected. Click a bubble on the map or adjust the timeframe using the sliders.</p>
    </div>
  </div>
</template>

<script>
import { Filter } from "../lib/Filter";

export default {
  name: "MapPanel",
  computed: {
    endYear: function() {
      return this.extent[1].getFullYear()
    },
    startYear: function() {
      return this.extent[0].getFullYear()
    },
    sortedData: function() {
      if (!this.data) return [];
      let sort = this.sortOptions.filter(d => d.id == this.sortKey)[0];
      let sortedData = [...this.data].sort(sort.method);
      if (sort.reverse) {
        sortedData.reverse();
      }
      if (this.sortDirection == "desc") {
        sortedData.reverse();
      }
      return sortedData;
    }
  },

  methods: {
    clearSelect: function() {
      this.$emit("clear-select");
    },
    setHoverPlace: function(occ) {
      this.hoverPlace = occ;
    },
    setPlace: function(field, conditions, clear) {
      this.$emit("select-data", { field, conditions, clear });
    },
    getPhotoUrl: function(url, size) {
      // vars to be moved to settings
      var stockphoto =
        "https://res-3.cloudinary.com/crunchbase-production/image/upload/c_lpad,h_120,w_120,f_auto,b_white,q_auto:eco/v1399231516/kfdi3wbrzjitcjvpmeii.jpg";
      var sizeindicator = "dw=";

      var a = url.indexOf('<img src="');
      if (a != -1) {
        var b = url.indexOf(sizeindicator);
        return url.substring(a + 10, b) + sizeindicator + size;
      } else {
        return stockphoto;
      }
    },
    whereFrom: function(data) {
      var places = [],
        i;
      for (i = 0; i < data.length; i++) {
        places.push(data[i].place_name);
      }
      return places.sort();
    },

    occurances: function(placedata) {
      var a = [],
        i,
        j,
        skip;
      a.push([placedata[0], 1]);
      for (i = 1; i < placedata.length; i++) {
        skip = false;
        for (j in a) {
          if (placedata[i] === a[j][0]) {
            a[j][1]++;
            skip = true;
          }
        }
        if (!skip) {
          a.push([placedata[i], 1]);
        }
      }
      return a;
    },

    setSortKey: function(key) {
      if (key == this.sortKey) {
        this.sortDirection = this.sortDirection == "asc" ? "desc" : "asc";
      }
      this.sortKey = key;
    }
  },

  data() {
    return {
      siteUrl: "https://acoustics.mpiwg-berlin.mpg.de/node/",
      sortOptions: [
        {
          id: "title",
          label: "Title",
          method: (a, b) => ('' + a.title).localeCompare(b.title)
        },
        {
          id: "date",
          label: "Date",
          method: (a, b) =>
            +b.field_object_year_start - +a.field_object_year_start,
          reverse: false
        },
        {
          id: "place",
          label: "Place",
          method: (a, b) => ('' + a.place_name).localeCompare(b.place_name)
        },
        {
          id: "author",
          label: "Author",
          method: (a, b) => ('' + a.last_name).localeCompare(b.last_name)
        }
      ],
      sortKey: "title",
      filter_place: "sometown",
      sortDirection: "asc",
      selected: false
    };
  },
  props: {
    data: Array,
    extent: Array,
    placeFilter: Filter
  }
};
</script>

<style lang="less" scoped>
@bgColorPanel: #efefef;
@bgColorItems: #fff;
@margin: 8px;

.panel {
  background-color: @bgColorPanel;
  font-family: "Source Serif Pro", serif;

  > div {
    height: 100vh;
    padding: @margin;
  }

  a {
    text-decoration: none;
    color: black;
    cursor: pointer;
  }

  p > a {
    text-decoration: underline;
  }

  h2, h3 {
    font-family: "Roboto Condensed", sans-serif;
  }

  ul {
    margin-left: 0;
    padding-left: 1rem;
  }

  .items {
    list-style: none;
    padding: 0;
    li {
      margin: @margin 0px;
      padding: @margin;
      border: 1px solid rgb(183, 183, 183);
      background: @bgColorItems;
      h3 {
        margin-top: 0;
      }
      img {
        width: 100%;
      }
    }
  }

  .sorting {
    margin: 0px;
    padding: 0;
    font-family: "Roboto Condensed", sans-serif;
    list-style: none;
    &:before {
      content: "Sort by:";
      margin-right: 1em;
    }
    li {
      cursor: pointer;
      display: inline-block;
      padding-right: 2em;
      &.selected {
        font-weight: bold;
      }
    }
  }
}
</style>
